import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCanAddQuery, selectQueries } from './ir-generator.selectors';

@Injectable({ providedIn: 'root' })
export class IrGeneratorSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly queries = this._store.selectSignal(selectQueries);

  public readonly canAddQuery = this._store.selectSignal(selectCanAddQuery);
}
